/// <reference lib="dom" />

// Single source of truth for the business contact destinations used across the site.
// Outbound destinations (Instagram, WhatsApp) and device handlers (tel:, sms:) must keep
// their exact URL — nothing may be appended to them.

const BUSINESS_PHONE_DIGITS = '18138193701';

export const BUSINESS_PHONE_DISPLAY = '+1 (813) 819-3701';
export const BUSINESS_TEL_HREF = `tel:+${BUSINESS_PHONE_DIGITS}`;
export const BUSINESS_WHATSAPP_HREF = `https://wa.me/${BUSINESS_PHONE_DIGITS}`;
export const BUSINESS_INSTAGRAM_HREF = 'https://instagram.com/arno.adornier';

/** Pre-filled message used by the "Send us a text" option. */
export const BUSINESS_TEXT_BODY = 'Hey, I would like more information';

/** iOS and iPadOS need `?body=`, Android messaging apps need `&body=`. */
export const isAppleMobile = (userAgent: string, maxTouchPoints = 0): boolean =>
  /iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1);

export const buildSmsHref = (body = BUSINESS_TEXT_BODY, appleDevice = false): string =>
  `sms:+${BUSINESS_PHONE_DIGITS}${appleDevice ? '?' : '&'}body=${encodeURIComponent(body)}`;
